import { useRosterState } from "amazon-chime-sdk-component-library-react";
import { VideoUIRoster } from "./VideoUIRoster";

export function VideoUIRosterContainer() {
  const { roster } = useRosterState();

  return <VideoUIRoster roster={roster} />;
}

export default VideoUIRosterContainer;
